import { render } from "./TgOpenAi.vue?vue&type=template&id=3ea14bd6"
import script from "./TgOpenAi.vue?vue&type=script&lang=js"
export * from "./TgOpenAi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__